"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
* firstInvoiceSent (AccPlatform version)
agreementSent
agreementAccepted
*
* */
